import type { ApolloError } from '@apollo/client'
import { useCallback } from 'react'

import {
  Dispensary,
  GetDispensaryByCodeDocument,
  GetDispensaryByCodeQueryVariables,
} from '../../../graphql/search'
import { useSearchLazyQuery } from '../../search'

export type UseDispensaryByCodeLazy = [
  getDispensaryByCode: (options: GetDispensaryByCodeQueryVariables) => void,
  result: {
    loading: boolean
    data: Dispensary | null
    error?: ApolloError | Error | string
    called: boolean
  },
]

export const useDispensaryByCodeLazy = (): UseDispensaryByCodeLazy => {
  const [doGetDispensaryByCode, { loading, data: responseData, error, called }] =
    useSearchLazyQuery(GetDispensaryByCodeDocument)

  const data = responseData?.dispensaryByCode || null

  const getDispensaryByCode = useCallback(
    ({ code }: GetDispensaryByCodeQueryVariables) => {
      doGetDispensaryByCode({ variables: { code } })
    },
    [doGetDispensaryByCode],
  )

  return [
    getDispensaryByCode,
    {
      loading,
      data,
      error,
      called,
    },
  ]
}
